<!-- 大屏总表 -->
<template>
    <div class="score-table">
        <div v-if="isShow" class="table-content">
            <div class="title">{{ title }}</div>
            <el-table :data="tableData" class="custom-table custom-table2"
                :row-class-name="tableRowClassName"
                style="width: 100%" border>
                <el-table-column prop="rank" label="名次" align="center" width="80px"/>                 
                <el-table-column prop="username" label="选手" align="center" width="120px"/> 
                <el-table-column prop="partnerName" label="搭档" align="center" width="120px" v-if="pubType ==='2'"/> 
                <el-table-column prop="company" label="协会(俱乐部)" align="center" width="150px"/>
                <el-table-column v-for="(item,index) in roundLength " :key="item+'a'" :label="`第${index+1}轮`" align="center">            
                    <!-- <el-table-column label="对手"  v-if="pubType ==='2'" align="center">
                        <template slot-scope="scope">{{ scope.row.round[index].playersId2}}</template>
                    </el-table-column>  
                    <el-table-column label="同桌"  v-if="pubType === '1'" align="center">
                        <template slot-scope="scope">{{ scope.row.round[index].playersId}}</template>
                    </el-table-column> -->
                    <el-table-column label="得分" align="center">
                        <template slot-scope="scope">{{ scope.row.round[index].score}}</template>
                    </el-table-column> 
                    <el-table-column label="级差分" align="center">
                        <template slot-scope="scope">{{ scope.row.round[index].minus}}</template>
                    </el-table-column>  
                </el-table-column>     
                <el-table-column   
                    v-for="(item, index) in dynamicHeaders"
                    :key="index"
                    :prop="item.prop"
                    :label="item.label" 
                    align="center">
                </el-table-column>
            </el-table> 
        </div>
    </div>
 </template>
 
 <script>
import { mapState } from 'vuex'

 export default {
     data() {
         return {
            loading:false,
            dataList: [],
            tableData:[], 
            roundLength: 1, 
            errorMessage: '',
            isShow: false,
            tableHeaders: [
                {label: '积分', prop: 'score'},
                {label: '胜轮次', prop: 'winNum'},
                {label: '级差总分', prop: 'totalRank'},
                {label: '升级数', prop: 'number'},
                {label: '搭档总分', prop: 'partnerScore'},
                {label: '对手总分', prop: 'totalPlayers'},
                {label: '对手总级差分', prop: 'totalMinusPlayers'},               
                {label: '搭档总级差分', prop: 'partnerRank'},
            ],
            pubId: '',
            pubType: '',
         }
     },
     created() {
        this.pubId = this.$route.query.id
        this.pubType = this.$route.query.type
        this.openFullScreen()
     },
     mounted() {
        this.initData()
        this.getTitle()
        document.addEventListener('click', this.toggleFullScreen);
     },
     computed:{
        ...mapState(['round'])
     },
     methods: {  
        tableRowClassName({row, rowIndex}){
            // 前三名不同的颜色
            if(row.rank === 1){
                return 'gold-row'
            }else if(row.rank === 2){
                return  'silver-row'
            }else if(row.rank === 3){
                return  'brown-row'
            }
        },
        openFullScreen() {
            let loading = this.$loading({
                lock: true,
                text: '成绩排名总成绩计算中，请稍后...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            setTimeout(() => {
                loading.close();
            }, 8000);
        },
        getTitle(){
            let params = {
                opcode: this.$code.PublishQuery,
                i_serial_mark: this.pubId,
                c_status: '',
                v_type: '',
                v_theme: '',
                start_date: '',
                end_date: '',
                pagesize: 10,
                page: 1,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    let list = result.map(item=>{                        
                        return{
                            title: item['主题'],
                        }
                    })
                    this.title = list[0].title +'成绩总排名'
                }
            })
        },
        //赛事排名查看
        initData(){
            let params = {
                opcode: this.$code.RankScore,
                i_serial_mark: this.pubId,
             }       
             this.loading = true     
             this.$api._requestAPI(params).then(async  res =>{
                 if (res.IsSuccess) {                    
                    let result = res.Data.DataTable
                    let arr = result.map(item=>{                    
                        return{
                            playersId: item['选手编号'],
                            username: item['选手'],
                            rank: item['名次'],
                            score: item['积分'],
                            number: item['升级数'],                           
                            totalRank: item['级差总分'],
                            totalPlayers: item['对手总分'],
                            totalMinusPlayers: item['对手总级差分'],
                            partnerScore: item['搭档总分'],
                            partnerRank: item['搭档总级差分'],
                            partnerName: item['搭档'],
                            totalScore: item['累计分'],
                            winNum: item['胜轮次'],    
                            company: item['单位'],                        
                        }
                    }) 
                    let newArr = [] 

                    for (const obj of arr) {
                        let roundList = await this.getRoundList(obj.playersId)
                        this.roundLength = roundList.length             
                        newArr.push({
                            round: roundList,
                            ...obj
                        })
                    }   
                    // console.log(newArr)
                    this.tableData = newArr
                    this.errorMessage = ''
                    let outputArry = this.$help.transformObjectToArrayTotal(result[0])
                    this.isShow = true
                    // 获取所有唯一的字段名
                    const fields = Array.from(new Set(this.tableData.flatMap(Object.keys)));
                    // 过滤出至少有一个非空值的字段
                    let filterArrNew= fields.filter(field => this.tableData.some(row => row[field] !== null && row[field] !== undefined && row[field] !== ''));
                    this.dynamicHeaders = outputArry.filter(i=>filterArrNew.includes(i.prop))
                 }else{
                    this.isShow = false
                    this.errorMessage = res.Message
                    this.$message.error(res.Message)
                    
                 }
             })  
        },
        getRoundList(num){
            return new Promise((resolve,reject)=>{
                let params = {
                    opcode: this.$code.RankScorePartner,
                    i_serial_mark: this.pubId,
                    i_players_number: num
                }
                this.$api.requestAPI(params).then(res =>{
                    if (res.IsSuccess) {
                        let result = res.Data.DataTable  
                        let arr = result.map(item=>{
                            return{
                                round:item['轮数'],
                                playersId: item['同桌'],
                                playersId2: item['对手'],
                                score: item['成绩'],
                                rank: item['积分'],
                                minus: item['级差分'],
                            }
                        })
                        this.roundLength = arr.length
                        resolve(arr)
                    }
                })               
            })
        },  
        toggleFullScreen(){
            if (!document.fullscreenElement) {
                this.$help.enterFullScreen();
            } else {
                this.$help.exitFullScreen();
            }
        },   
     },
     beforeDestroy() {
        // 在实例销毁前移除事件监听
        document.removeEventListener('click', this.toggleFullScreen);
    },
 }
 </script>
 <style lang='scss' scoped>
 @import '@/assets/css/style.scss';
 .title{
    font-size: 28px;
    text-align: center;
    color: gold;
    padding: 10px 0;
    background-color: #de2c11;
 }
 .table-content{
    overflow: scroll;
 }
 table {
     width: 100%;
     border-collapse: collapse;
   }
   th, td {
     border: 1px solid #999;
     padding: 8px;
     text-align: left;
     font-size: 18px;
   }
   tbody tr:hover{
        background-color:#f5f5f5
   }
//    tr:nth-child(even) {
//      background-color: lightblue;
//    }
   thead th {
     background-color: #f2f2f2;
     font-size: 16px;
     text-align: center;
   }
   .table-label {
     display: flex;
     justify-content: space-between;
     align-items: center;
     padding: 10px;
     background-color: #f9f9f9;
     border: 1px solid #ddd;
   }
   .custom-table >>> .el-table__header-wrapper tr th{
    // font-size: 18px;
    // color: #333;
}
.custom-table >>> .gold-row{
    background-color: #FFD700;
}
.custom-table >>> .silver-row{
    background-color: #C0C0C0;
}
.custom-table >>> .brown-row{
    background-color: #CD7F32;
}
 </style>


// WEBPACK FOOTER //
// src/views/fullScreen/fullTotalTank.vue